// @Version: 1.0.0
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
   providedIn: 'root'
})

export class IsRequiredService {

   private isRequired$_: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)
   public isRequired: Observable<boolean> = this.isRequired$_.asObservable()
   
   constructor () { }

   get required (): boolean {
      return this.isRequired$_.value;
   }  
   
   set required (value: boolean) {
      this.isRequired$_.next(value);
   }
}
